import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/shared/Notification.service';

import { ProductInfo } from 'src/app/shared/ProductInfo.model';
import { ProductInfoService } from 'src/app/shared/ProductInfo.service';

import { ProductInfoDocuments } from 'src/app/shared/ProductInfoDocuments.model';
import { ProductInfoDocumentsService } from 'src/app/shared/ProductInfoDocuments.service';

import { ThanhVien } from 'src/app/shared/ThanhVien.model';
import { ThanhVienService } from 'src/app/shared/ThanhVien.service';
import { CommonService } from '../shared/common.service';

@Component({
  selector: 'app-co-so-product-info-detail',
  templateUrl: './co-so-product-info-detail.component.html',
  styleUrls: ['./co-so-product-info-detail.component.css']
})
export class CoSoProductInfoDetailComponent implements OnInit {
  @ViewChild('ProductInfoDocumentsSort') ProductInfoDocumentsSort: MatSort;
  @ViewChild('ProductInfoDocumentsPaginator') ProductInfoDocumentsPaginator: MatPaginator;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<CoSoProductInfoDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    public NotificationService: NotificationService,

    public ProductInfoService: ProductInfoService,
    public ProductInfoDocumentsService: ProductInfoDocumentsService,

    public ThanhVienService: ThanhVienService,
    public CommonService: CommonService
  ) { }

  private fixLegacyDomain(url: string): string {
    return url ? url.replace('bentre.gov.vn', 'vinhlong.gov.vn') : url;
  }

  DisableForm: boolean = false;
  ngOnInit(): void {
    this.ThanhVienGetLogin();
    this.ProductInfoDocumentsSearch();
    this.CheckIsConfirm();
  }
  CheckIsConfirm(){
    if(this.ProductInfoService.FormData.ID>0 && this.ProductInfoService.FormData.Active === true){
      this.DisableForm = true;
      return;
    }
    this.DisableForm = false;
  }
  DateNgayGhiNhan(value) {
    this.ProductInfoService.FormData.NgayGhiNhan = new Date(value);
  }

  ThanhVienGetLogin() {
    this.ThanhVienService.GetLogin();
  }
  ProductInfoSave() {
    // Chặn save trên mobile
    if (this.NotificationService.blockMobileActionIfNeeded()) {
      return;
    }
    
    this.ProductInfoService.FormData.ParentID = this.ThanhVienService.FormDataLogin.CompanyInfoID;
    this.ProductInfoService.IsShowLoading = true;
    this.ProductInfoService.SaveAsync().subscribe(
      res => {
        this.ProductInfoService.FormData = res as ProductInfo;
        if (this.ProductInfoService.FormData) {
          if (this.ProductInfoService.FormData.ID) {
            if (this.ProductInfoDocumentsService.FileToUpload) {
              if (this.ProductInfoDocumentsService.FileToUpload.length > 0) {

                this.ProductInfoService.IsShowLoading = true;
                this.ProductInfoDocumentsService.FormData.ParentID = this.ProductInfoService.FormData.ID;
                this.ProductInfoDocumentsService.FormData.Name = this.ProductInfoService.FormData.Name;
                this.ProductInfoDocumentsService.FormData.Code = this.ProductInfoService.FormData.Code;
                this.ProductInfoDocumentsService.FormData.DocumentTemplateID = 333333;
                this.ProductInfoDocumentsService.SaveAndUploadFileAsync().subscribe(
                  res => {
                    this.ProductInfoDocumentsSearch();
                    this.ProductInfoService.IsShowLoading = false;
                    this.NotificationService.warn(environment.SaveSuccess);
                  },
                  err => {
                    this.NotificationService.warn(environment.SaveNotSuccess);
                    this.ProductInfoService.IsShowLoading = false;
                  }
                );

              }else{
                this.ProductInfoService.IsShowLoading = false;
                this.NotificationService.warn(environment.SaveSuccess);
              }
            }else{
              this.ProductInfoService.IsShowLoading = false;
              this.NotificationService.warn(environment.SaveSuccess);
            }
          }else{
            this.ProductInfoService.IsShowLoading = false;
            this.NotificationService.warn(environment.SaveNotSuccess);
          }
        }else{
          this.ProductInfoService.IsShowLoading = false;
          this.NotificationService.warn(environment.SaveNotSuccess);
        }
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.ProductInfoService.IsShowLoading = false;
      }
    );
  }
  ChangeFileName(files: FileList) {
    if (files) {
      this.ProductInfoDocumentsService.FileToUpload = files;
    }
  }
  
  openFileInput(){
    this.fileInput.nativeElement.click();
  }
  publicDoc: ProductInfoDocuments;
  ProductInfoDocumentsSearch() {
    this.ProductInfoService.IsShowLoading = true;
    this.ProductInfoDocumentsService.BaseParameter.ParentID = this.ProductInfoService.FormData.ID;
    this.ProductInfoDocumentsService.GetByParentIDAndEmptyToListAsync().subscribe(
      res => {
        this.ProductInfoDocumentsService.List = (res as ProductInfoDocuments[]).sort((a, b) => (a.ID < b.ID ? 1 : -1));
        this.publicDoc = this.ProductInfoDocumentsService.List.find(p=>p.FileName !== null && this.ProductInfoService.FormData.ID>0);
        this.ProductInfoDocumentsService.DataSource = new MatTableDataSource(this.ProductInfoDocumentsService.List);
        this.ProductInfoDocumentsService.DataSource.sort = this.ProductInfoDocumentsSort;
        this.ProductInfoDocumentsService.DataSource.paginator = this.ProductInfoDocumentsPaginator;
        this.ProductInfoService.IsShowLoading = false;
      },
      err => {
        this.ProductInfoService.IsShowLoading = false;
      }
    );
  }
  
  ProductInfoDocumentsSave(element: ProductInfoDocuments) {
    this.ProductInfoService.IsShowLoading = true;
    element.ParentID = this.ProductInfoService.FormData.ID;
    element.Name = this.ProductInfoService.FormData.Name;
    element.Code = this.ProductInfoService.FormData.Code;
    this.ProductInfoDocumentsService.FormData = element;
    this.ProductInfoDocumentsService.SaveAndUploadFileAsync().subscribe(
      res => {
        this.ProductInfoDocumentsSearch();
        this.NotificationService.warn(environment.SaveSuccess);
        this.ProductInfoService.IsShowLoading = false;
      },
      err => {
        this.NotificationService.warn(environment.SaveNotSuccess);
        this.ProductInfoService.IsShowLoading = false;
      }
    );
  }
  ProductInfoDocumentsDelete(element: ProductInfoDocuments) {
    if (confirm(environment.DeleteConfirm)) {
      this.ProductInfoService.IsShowLoading = true;
      this.ProductInfoDocumentsService.BaseParameter.ID = element.ID;
      this.ProductInfoDocumentsService.RemoveAsync().subscribe(
        res => {
          this.ProductInfoDocumentsSearch();
          this.NotificationService.warn(environment.SaveSuccess);
          this.ProductInfoService.IsShowLoading = false;
        },
        err => {
          this.NotificationService.warn(environment.SaveNotSuccess);
          this.ProductInfoService.IsShowLoading = false;
        }
      );
    }
  }
  Close() {
    this.dialogRef.close();
  }

  getMimeType(fileName: string): string {
    if (fileName.endsWith('.pdf')) return 'application/pdf';
    if (fileName.endsWith('.doc')) return 'application/msword';
    if (fileName.endsWith('.docx')) return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    if (fileName.endsWith('.xls')) return 'application/vnd.ms-excel';
    if (fileName.endsWith('.xlsx')) return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    return '*/*';
  }

  openDownload(fileName: string): void {
    if (!fileName) {
      return;
    }

    try {
      const isCordovaEnv = !!(window as any).cordova;
      const fixedUrl = this.fixLegacyDomain(fileName);

      console.log('[CoSoProductInfoDetail] openDownload clicked, fileName =', fileName, 'fixedUrl =', fixedUrl, 'isCordovaEnv =', isCordovaEnv);

      if (isCordovaEnv) {
        // Android: Download file về local trước khi mở (dùng file gốc, không đổi extension)
        this.downloadAndOpenFile(fixedUrl, false);
      } else {
        // Web: mở tab mới như behavior cũ
        window.open(fixedUrl, '_blank');
      }
    } catch (error) {
      console.error('Error opening file:', error);
      this.NotificationService.warn('Không thể mở tập tin. Vui lòng thử lại trên trình duyệt.');
    }
  }

  openView(fileName: string): void {
    if (!fileName) {
      return;
    }

    const isCordovaEnv = !!(window as any).cordova;
    const fixedUrl = this.fixLegacyDomain(fileName);

    // Web: dùng viewer URL để hiển thị qua Google Docs Viewer (có thể chuyển docx/xlsx thành PDF URL)
    if (!isCordovaEnv) {
      const viewerUrl = this.CommonService.getViewerUrl(fixedUrl);
      const targetUrl = this.fixLegacyDomain(viewerUrl || fixedUrl);
      window.open(targetUrl, '_blank');
      return;
    }

    try {
      console.log('[CoSoProductInfoDetail] openView (Cordova) clicked, fileName =', fileName, 'fixedUrl =', fixedUrl);

      // Android: Download file về local trước khi mở (dùng file GỐC, không đổi extension)
      // Để app ngoài (Word/Excel) có thể mở được file docx/xlsx thật
      this.downloadAndOpenFile(fixedUrl, true);
    } catch (error) {
      console.error('Error opening file from openView:', error);
      this.NotificationService.warn('Không thể xem tập tin. Vui lòng thử lại trên trình duyệt.');
    }
  }

  downloadAndOpenFile(fileUrl: string, isView: boolean): void {
    try {
      fileUrl = this.fixLegacyDomain(fileUrl);

      const cordova = (window as any).cordova;
      const fileTransfer = (window as any).FileTransfer;

      // Kiểm tra FileTransfer plugin và cordova.file (không phải window.File)
      if (!fileTransfer || !cordova || !cordova.file) {
        console.warn('[CoSoProductInfoDetail] FileTransfer or File plugin not available', {
          hasFileTransfer: !!fileTransfer,
          hasCordova: !!cordova,
          hasCordovaFile: !!(cordova && cordova.file)
        });
        // Fallback: nếu là HTTPS URL thì không thể mở trực tiếp
        if (fileUrl.startsWith('http://') || fileUrl.startsWith('https://')) {
          this.NotificationService.warn('Không thể tải file. Plugin FileTransfer chưa được cài đặt.');
          return;
        }
        // Thử mở trực tiếp (có thể là file local)
        this.openFileDirectly(fileUrl);
        return;
      }

      // Lấy tên file từ URL (giữ nguyên extension gốc: .docx, .xlsx, .pdf, etc.)
      const fileName = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
      
      // Đường dẫn lưu file tạm
      const filePath = cordova.file.externalCacheDirectory || cordova.file.cacheDirectory;
      if (!filePath) {
        console.error('[CoSoProductInfoDetail] Cannot determine file cache directory');
        this.NotificationService.warn('Không thể xác định thư mục lưu file. Vui lòng kiểm tra quyền truy cập.');
        return;
      }
      
      const targetPath = filePath + fileName;

      console.log('[CoSoProductInfoDetail] Downloading file from', fileUrl, 'to', targetPath);

      // Hiển thị thông báo đang tải (nếu là download)
      if (!isView) {
        this.NotificationService.warn('Đang tải file...');
      }

      const transfer = new fileTransfer();
      
      transfer.download(
        fileUrl,
        targetPath,
        (entry: any) => {
          // Sử dụng nativeURL để lấy đường dẫn file thực tế (file:///...)
          // Thay vì toURL() trả về Cordova file URL (https://app/__cdvfile_...)
          const filePath = entry.nativeURL || entry.toInternalURL() || entry.toURL();
          console.log('[CoSoProductInfoDetail] Download success:', filePath);
          // Mở file sau khi download (file gốc với extension thật)
          this.openFileDirectly(filePath);
        },
        (error: any) => {
          console.error('[CoSoProductInfoDetail] Download error:', error);
          const errorCode = error?.code || error?.status || 'UNKNOWN';
          let errorMessage = 'Không thể tải file.';
          
          // Hiển thị thông báo chi tiết hơn dựa vào error code
          if (errorCode === 1 || errorCode === 'FILE_NOT_FOUND') {
            errorMessage = 'Không tìm thấy file trên server. File có thể đã bị xóa hoặc không tồn tại.';
          } else if (errorCode === 2 || errorCode === 'INVALID_URL') {
            errorMessage = 'URL không hợp lệ. Vui lòng kiểm tra lại đường dẫn file.';
          } else if (errorCode === 3 || errorCode === 'CONNECTION_ERR') {
            errorMessage = 'Lỗi kết nối. Vui lòng kiểm tra kết nối internet và thử lại.';
          } else {
            errorMessage = `Không thể tải file (Lỗi: ${errorCode}). Vui lòng thử lại.`;
          }
          
          this.NotificationService.warn(errorMessage);
          
          // Nếu download thất bại và là file local, thử mở trực tiếp
          if (!fileUrl.startsWith('http://') && !fileUrl.startsWith('https://')) {
            this.openFileDirectly(fileUrl);
          }
        },
        false,
        {
          headers: {}
        }
      );
    } catch (error) {
      console.error('[CoSoProductInfoDetail] Error in downloadAndOpenFile:', error);
      this.NotificationService.warn('Lỗi khi xử lý file. Vui lòng thử lại.');
    }
  }

  openFileDirectly(filePath: string): void {
    try {
      const cordova = (window as any).cordova;
      
      console.log('[CoSoProductInfoDetail] Opening file:', filePath);
      
      // Kiểm tra xem filePath có phải là HTTPS/HTTP URL thực sự không (không phải Cordova file URL)
      // Cordova file URL có dạng: https://app/__cdvfile_sdcard__/... hoặc cdvfile://...
      // File path thực tế có dạng: file:///storage/emulated/0/...
      if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
        // Nếu là Cordova file URL (chứa __cdvfile__), cần resolve sang file path thực tế
        if (filePath.includes('__cdvfile__') || filePath.includes('cdvfile://')) {
          // Thử resolve Cordova file URL sang file path thực tế
          if (cordova && cordova.file && cordova.file.resolveLocalFileSystemURL) {
            cordova.file.resolveLocalFileSystemURL(filePath, 
              (entry: any) => {
                const realPath = entry.nativeURL || entry.toInternalURL();
                console.log('[CoSoProductInfoDetail] Resolved Cordova URL to:', realPath);
                this.openFileDirectly(realPath);
              },
              (error: any) => {
                console.error('[CoSoProductInfoDetail] Cannot resolve Cordova file URL:', error);
                this.NotificationService.warn('Không thể mở file. Vui lòng thử lại.');
              }
            );
            return;
          } else {
            // Fallback: thử convert thủ công từ Cordova URL sang file path
            // https://app/__cdvfile_sdcard__/Android/data/... -> file:///storage/emulated/0/Android/data/...
            const convertedPath = filePath.replace(/https:\/\/app\/__cdvfile_sdcard__\//, 'file:///storage/emulated/0/');
            if (convertedPath !== filePath && convertedPath.startsWith('file://')) {
              console.log('[CoSoProductInfoDetail] Converted Cordova URL to:', convertedPath);
              filePath = convertedPath;
            } else {
              console.warn('[CoSoProductInfoDetail] Cannot open HTTPS URL directly, need to download first');
              this.NotificationService.warn('Không thể mở file từ URL. Vui lòng thử tải về trước.');
              return;
            }
          }
        } else {
          // Là HTTPS/HTTP URL thực sự, không thể mở trực tiếp
          console.warn('[CoSoProductInfoDetail] Cannot open HTTPS URL directly, need to download first');
          this.NotificationService.warn('Không thể mở file từ URL. Vui lòng thử tải về trước.');
          return;
        }
      }
      
      // Mở file bằng fileOpener2 với file gốc (giữ nguyên extension: .docx, .xlsx, .pdf)
      cordova.plugins.fileOpener2.open(
        filePath,
        this.getMimeType(filePath),
        {
          error: (e: any) => {
            console.error('[CoSoProductInfoDetail] Open error:', e);
            const errorCode = e?.status || e?.code || 'UNKNOWN';
            let errorMessage = 'Không thể mở file.';
            
            // Hiển thị thông báo chi tiết hơn dựa vào error code
            if (errorCode === 1 || errorCode === 'FILE_NOT_FOUND') {
              errorMessage = 'Không tìm thấy file. File có thể đã bị xóa hoặc không tồn tại.';
            } else if (
              errorCode === 9 || // Activity not found / No activity to handle intent
              errorCode === 5 || // NO_APP_FOUND theo tài liệu plugin
              errorCode === 10 ||
              errorCode === 'NO_APP_FOUND'
            ) {
              errorMessage = 'Không có ứng dụng để mở file này. Vui lòng cài đặt ứng dụng phù hợp (Word, Excel, PDF Viewer).';
            } else {
              errorMessage = `Không thể mở file (Lỗi: ${errorCode}). Vui lòng thử lại hoặc cài ứng dụng phù hợp (Word, Excel, PDF Viewer).`;
            }
            
            this.NotificationService.warn(errorMessage);
          },
          success: () => {
            console.log('[CoSoProductInfoDetail] File opened successfully');
          }
        }
      );
    } catch (error) {
      console.error('[CoSoProductInfoDetail] Error in openFileDirectly:', error);
      this.NotificationService.warn('Lỗi khi mở file. Vui lòng thử lại.');
    }
  }
}
